import React, { useRef, useCallback } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Webcam from 'react-webcam'
import { Typography } from '@material-ui/core'
import IconPicker from '../../../apps/AppComponents/IconPicker/IconPicker'

const MyProfileCamera = ({
  classes,
  showCameraPreview,
  updateShowCameraPreview,
  updateImage,
}) => {
  const webcamRef = useRef(null)

  const convertBase64ToBlob = async (base64) => {
    const response = await fetch(base64)
    const blob = await response.blob()
    return blob
  }

  const capture = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot()
    const blob = await convertBase64ToBlob(imageSrc)
    updateImage(URL.createObjectURL(blob))
    updateShowCameraPreview(!showCameraPreview)
  }, [webcamRef])

  return (
    <Box display="flex" flexDirection="column">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" />
      </Box>
      <Box
        className={classes.screenshotContainer}
        display="flex"
        flexDirection="row"
      >
        <Button
          className={classes.cropNowActionButton}
          variant="contained"
          color="primary"
          onClick={capture}
        >
          <div className={classes.cropIcon}>
            <IconPicker iconName="fa-solid fa-camera" size="1x" />
          </div>
          <Typography variant="h5">Take Picture</Typography>
        </Button>
      </Box>
    </Box>
  )
}

export default MyProfileCamera
